<template>
	<div class="d-flex align-center">
		<button
			class="rounded-circle border-xs bg-neutral-25 button-counter"
			:class="
				count === min
					? 'cursor-not-allowed border-neutral-400 text-neutral-400'
					: 'border-neutral-900 text-neutral-900'
			"
			:disabled="count === min"
			@click="count--"
		>
			-
		</button>
		<p class="text-title-s pa-2">
			{{ count }}
		</p>
		<button
			class="rounded-circle border-xs bg-neutral-25 button-counter"
			:class="
				count === max
					? 'cursor-not-allowed border-neutral-400 text-neutral-400'
					: 'border-neutral-900 text-neutral-900'
			"
			:disabled="count === max"
			@click="count++"
		>
			+
		</button>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		min?: number
		max?: number
	}

	withDefaults(defineProps<Props>(), {
		min: 0,
		max: undefined,
	})
	const count = defineModel<number>({ default: 0 })
</script>

<style scoped lang="scss">
	.button-counter {
		width: 24px;
		height: 24px;
		&:not(:disabled):hover {
			cursor: pointer;
			color: var(--color-neutral-900);
			background-color: var(--color-neutral-100);
		}
	}
</style>
